import isEqual from 'lodash/isEqual';
import moment from 'moment';
import { IRNComplianceSummary } from '../common/types';
import { getCursor, writeData } from './db';
import { appConfig } from '../config/app-config';
import {
  CursorAccess,
  DATE_FORMAT,
  MIS_COMPLIANCE_INDEX,
  QueryType,
} from './constants';
import { MisComplianceEntity } from '../common/entity';

export const getComplianceSummaryFromDB = async (
  orgId: string,
  invoiceStartDate: moment.Moment,
  invoiceEndDate: moment.Moment
): Promise<IRNComplianceSummary[] | undefined> => {
  try {
    let cursor = await getCursor(
      appConfig.IDB.STORE.MIS_COMPLIANCE,
      MIS_COMPLIANCE_INDEX.ORG_ID_INDEX.NAME,
      orgId,
      CursorAccess.READ_ONLY,
      QueryType.ONLY
    );

    while (cursor) {
      if (
        moment(cursor.value.invoiceStartDate).format(DATE_FORMAT) ===
          invoiceStartDate.format(DATE_FORMAT) &&
        moment(cursor.value.invoiceEndDate).format(DATE_FORMAT) ===
          invoiceEndDate.format(DATE_FORMAT)
      ) {
        return cursor.value.summary as IRNComplianceSummary[];
      }
      cursor = await cursor.continue();
    }
  } catch (e) {
    // console.log('Failed to get compliance summary from db', e);
  }
};

export const createOrUpdateComplianceSummary = async (
  orgId: string,
  invoiceStartDate: moment.Moment,
  invoiceEndDate: moment.Moment,
  summary: IRNComplianceSummary[]
) => {
  try {
    let cursor = await getCursor(
      appConfig.IDB.STORE.MIS_COMPLIANCE,
      MIS_COMPLIANCE_INDEX.ORG_ID_INDEX.NAME,
      orgId,
      CursorAccess.READ_WRITE,
      QueryType.ONLY
    );

    while (cursor) {
      if (
        moment(cursor.value.invoiceStartDate).format(DATE_FORMAT) ===
          invoiceStartDate.format(DATE_FORMAT) &&
        moment(cursor.value.invoiceEndDate).format(DATE_FORMAT) ===
          invoiceEndDate.format(DATE_FORMAT)
      ) {
        if (isEqual(cursor.value.summary, summary)) return;
        cursor.value.summary = summary;
        // @ts-ignore
        cursor.update(cursor.value);
        return;
      }
      cursor = await cursor.continue();
    }
    const complianceSummary: MisComplianceEntity = {
      orgId,
      invoiceStartDate: invoiceStartDate.toDate(),
      invoiceEndDate: invoiceEndDate.toDate(),
      summary,
    };
    await writeData(appConfig.IDB.STORE.MIS_COMPLIANCE, complianceSummary);
  } catch (e) {
    // console.log('Failed to update compliance db', e);
  }
};
